import FormGroupInput from "./Inputs/formGroupInput.vue";

import DropDown from "./Dropdown/Dropdown.vue";
import PaperTable from "./Tables/PaperTable.vue";
import Button from "./Buttons/Button";

import Card from "./Cards/Card.vue";
import ChartCard from "./Cards/ChartCard.vue";
import StatsCard from "./Cards/StatsCard.vue";
import ProfileCard from "./ProfileChoiceCard.vue";
import ParcListSearchCard from "./ParcListSearchCard.vue";
import ParcListParcCard from "./ParcListParcCard.vue";
import ParcProfileParcCard from "./ParcProfileParcCard.vue";
import ParcProfileDates from "./ParcProfileDates.vue";
import ParcProfileDatesRenouvellement from "./ParcProfileDatesRenouvellement.vue";
import ParcProfileEolienneList from "./ParcProfileEolienneList.vue";
import ParcProfilePosteLivraisonList from "./ParcProfilePosteLivraisonList.vue";
import ToastNotification from "@/components/Notifications/ToastNotification.vue";
import SidebarPlugin from "./SidebarPlugin/index";

let components = {
  FormGroupInput,
  Card,
  ChartCard,
  StatsCard,
  ProfileCard,
  ParcListParcCard,
  ParcListSearchCard,
  ParcProfileParcCard,
  ParcProfileDates,
  ParcProfileDatesRenouvellement,
  ParcProfileEolienneList,
  ParcProfilePosteLivraisonList,
  PaperTable,
  DropDown,
  SidebarPlugin,
  ToastNotification
};

export default components;

export {
  FormGroupInput,
  Card,
  ChartCard,
  StatsCard,
  ProfileCard,
  ParcListParcCard,
  ParcListSearchCard,
  ParcProfileParcCard,
  ParcProfileDates,
  ParcProfileDatesRenouvellement,
  ParcProfileEolienneList,
  ParcProfilePosteLivraisonList,
  PaperTable,
  DropDown,
  Button,
  SidebarPlugin,
  ToastNotification
};
